<template>
  <div class="row">
    <div class="col-md-6">
      <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <img :src="product.bild_url" alt="Produktbild" style="width: 165px; height: auto;">
      </a>
    </div>
    <div class="col-md-6 d-flex flex-column align-items-center justify-content-center">
      <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <button class="btn14 px-1 py-1">Auf Amazon ansehen*</button>
      </a>
    </div>
  </div>
  
  <div class="product-tabs mt-2">
    <input :id="'tab1-' + product.id" type="radio" :name="'tabs-' + product.id" checked="checked" />
    <input :id="'tab2-' + product.id" type="radio" :name="'tabs-' + product.id" />
    <input :id="'tab3-' + product.id" type="radio" :name="'tabs-' + product.id" />

    <ul class="tabs">
      <li class="tab"><label :for="'tab1-' + product.id">Allgemeines</label></li>
      <li class="tab"><label :for="'tab2-' + product.id">Zubereitung</label></li>
      <li class="tab"><label :for="'tab3-' + product.id">Ausstattung</label></li>
    </ul>

    <div class="tab-content">
      <div class="display-properties">
        <div class="property">
          <label>Marke</label>
          <span>{{ product.marke || 'Keine Angabe' }}</span>
        </div>

        <div class="property">
          <label>Maschinentyp</label>
          <span>{{ product.produkttyp || 'Keine Angabe' }}</span>
        </div>

        <div class="property">
          <label>Maße in mm (B/T/H)</label>
          <span v-if="product.breite_mm && product.tiefe_mm && product.hoehe_mm">
            {{ product.breite_mm }} x {{ product.tiefe_mm }} x {{ product.hoehe_mm }}
          </span>
          <span v-else>kA</span>
        </div>
        <div class="property">
          <label>Wassertank</label>
          <span v-if="product.fassungsvermoegen_wassertank">{{ product.fassungsvermoegen_wassertank }} l</span>
          <span v-else>Keine Angabe</span>
        </div>

          <div class="property">
          <label>Kaffee-Einfüllart</label>
          <span>{{ product.kaffee_einfuellart || 'Keine Angabe' }}</span>
        </div>

        <div class="property">
          <label>Pumpendruck</label>
          <span v-if="product.maximaler_betriebsdruck_bar">{{ product.maximaler_betriebsdruck_bar }} Bar</span>
          <span v-else>Keine Angabe</span>
        </div>

        <div class="property">
          <label>Milchsystem</label>
          <span>{{ product.art_milchzugabe || 'Keine Angabe' }}</span>
        </div>

        <div class="property">
          <label>Zwei Tassen gleichzeitig</label>
          <span v-if="product.zwei_tassen_auf_einmal == 1">Ja</span>
          <span v-else-if="product.zwei_tassen_auf_einmal == 0">Nein</span>
          <span v-else>keine Angabe</span>
        </div>

      </div>
    </div>

    <div class="tab-content">
      <div class="display-properties">

                 <div class="property">
          <label>Caffè Latte</label>
          <span v-if="product.zubereitung_caffe_latte == 1">Ja</span>
          <span v-else-if="product.zubereitung_caffe_latte == 0 || product.zubereitung_caffe_latte == 2">Nein</span>
          <span v-else>keine Angabe</span>
          </div>
  <div class="property">
  <label>Espresso</label>
  <span v-if="product.espressozubereitung == 1">Ja</span>
  <span v-else-if="product.espressozubereitung == 0">Nein</span>
  <span v-else>keine Angabe</span>
</div>

<div class="property">
  <label>Cappuccino</label>
  <span v-if="product.zubereitung_cappuccino == 1">Ja</span>
  <span v-else-if="product.zubereitung_cappuccino == 0">Nein</span>
  <span v-else>keine Angabe</span>
</div>

<div class="property">
  <label>Latte Macchiato</label>
  <span v-if="product.zubereitung_latte_macchiato == 1">Ja</span>
  <span v-else-if="product.zubereitung_latte_macchiato == 0 || product.zubereitung_latte_macchiato == 2">Nein</span>
  <span v-else>keine Angabe</span>
</div>

<div class="property">
  <label>Café Crème</label>
  <span v-if="product.zubereitung_cafe_crema == 1">Ja</span>
  <span v-else-if="product.zubereitung_cafe_crema == 0 || product.zubereitung_cafe_crema == 2">Nein</span>
  <span v-else>keine Angabe</span>
</div>

<div class="property">
  <label>Americano</label>
  <span v-if="product.zubereitung_caffe_americano == 1">Ja</span>
  <span v-else-if="product.zubereitung_caffe_americano == 0 || product.zubereitung_caffe_americano == 2">Nein</span>
  <span v-else>keine Angabe</span>
</div>

<div class="property">
  <label>Milchkaffee</label>
  <span v-if="product.zubereitung_milchkaffee == 1">Ja</span>
  <span v-else-if="product.zubereitung_milchkaffee == 0 || product.zubereitung_milchkaffee == 2">Nein</span>
  <span v-else>keine Angabe</span>
</div>

<div class="property">
  <label>Café Lungo</label>
  <span v-if="product.zubereitung_caffe_lungo == 1">Ja</span>
  <span v-else-if="product.zubereitung_caffe_lungo == 0 || product.zubereitung_caffe_lungo == 2">Nein</span>
  <span v-else>keine Angabe</span>
</div>
<div class="property">
  <label>Café Lungo</label>
  <span v-if="product.zubereitung_caffe_ristretto == 1">Ja</span>
  <span v-else-if="product.zubereitung_caffe_ristretto == 0 || product.zubereitung_caffe_ristretto == 2">Nein</span>
  <span v-else>keine Angabe</span>
</div>
<div class="property">
  <label>Flat White</label>
  <span v-if="product.zubereitung_flat_white == 1">Ja</span>
  <span v-else-if="product.zubereitung_flat_white == 0 || product.zubereitung_flat_white == 2">Nein</span>
  <span v-else>keine Angabe</span>
</div>

      </div>
    </div>

    <div class="tab-content">
      <div class="display-properties">
        <div class="property">
          <label>Integriertes Mahlwerk</label>
          <span v-if="product.eingebautes_mahlwerk == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Milchaufschäumer inkl.</label>
          <span v-if="product.integrierter_milchaufschaeumer == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Eingebautes Display</label>
          <span v-if="product.eingebautes_display == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Heißwasser (für Tee)</label>
          <span v-if="product.heisswassersystem == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>WLAN / Smart Home</label>
          <span v-if="product.wlan == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Wasserfilter</label>
          <span v-if="product.wasserfilter == 1">Ja</span>
          <span v-else>Nein</span>
        </div>
      </div>

                      <div class="property">
          <label>Gewicht</label>
          <span v-if="product.gewicht_kg">{{ product.gewicht_kg }} kg</span>
          <span v-else>Keine Angabe</span>
        </div>
    </div>
  </div>
</template>

<script>
import StarRating from "./StarRating.vue";

export default {
  components: {
    StarRating
  },
  props: ['product'],
  mounted() {
  },
};
</script>

<style scoped>
.datasheet-btn {
  background-color: #e6e0d980;
  border: none;
  color: rgb(98, 94, 94);
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.custom-btn:hover {
  background-color: white;
  color: black;
  border: 2px solid #4CAF50;
}

.datasheet-table th {
  background-color: #e9d9c7;
  color: #0e0808;
  text-align: left;
}

.datasheet-table td,
.datasheet-table th {
  text-align: left;
  font-size: 14px;
}

.datasheet-table label {
  font-weight: bold;
}

.product-tabs {
  overflow-x: hidden;
  border-bottom: 1px solid #ccc;
}

.product-tabs [type="radio"] {
  display: none;
}

.tabs {
  display: flex;
  align-items: stretch;
  list-style: none;
  padding: 0px;
  border-bottom: 1px solid #ccc;
  margin: 0px;
}

.tab>label {
  display: block;
  margin-bottom: -1px;
  border: 1px solid #ccc;
  background: #eee;
  color: #666;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  padding: 2px;
}

.tab:hover label {
  border-top-color: #333;
  color: #333;
}

.tab-content {
  display: none;
  color: #777;
}

.product-tabs [type="radio"]:nth-of-type(1):checked~.tabs .tab:nth-of-type(1) label,
.product-tabs [type="radio"]:nth-of-type(2):checked~.tabs .tab:nth-of-type(2) label,
.product-tabs [type="radio"]:nth-of-type(3):checked~.tabs .tab:nth-of-type(3) label,
.product-tabs [type="radio"]:nth-of-type(4):checked~.tabs .tab:nth-of-type(4) label {
  border-bottom-color: #fff;
  border-top-color: #B721FF;
  background: #fff;
  color: #222;
}

.product-tabs [type="radio"]:nth-of-type(1):checked~.tab-content:nth-of-type(1),
.product-tabs [type="radio"]:nth-of-type(2):checked~.tab-content:nth-of-type(2),
.product-tabs [type="radio"]:nth-of-type(3):checked~.tab-content:nth-of-type(3),
.product-tabs [type="radio"]:nth-of-type(4):checked~.tab-content:nth-of-type(4) {
  display: block;
}

.custom-modal-body {
  padding: 0;
}

.display-properties {
  margin: 5px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.property {
  font-size: 15px;
}

label {
  font-weight: bold;
  display: block;
  font-size: 14px;
}

.mt-small-device {
  margin-top: 0;
}

@media (max-width: 576px) {
  .mt-small-device {
    margin-top: 5px;
  }
}

.btn14 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
  width: 70%;
  line-height: 1.3;
}
</style>